import { ModulePlaceholderList } from '../../components/ModulePlaceholderList';

export default function AllReviews() {
  return (
    <ModulePlaceholderList
      title="Performance reviews"
      newPath="/panel/performances/new"
      newLabel="New review"
    />
  );
}
